export const campodigital = [

 
  {
    nombre: "VENTANILLA PROGRAMA PRODUCTIVO PARA MUJER RURAL",
    enlace:
      "https://forms.gle/WEfeAWD8LQikBNPv8",
    anio: "2026",
    formatos: [
      {
        id: "1",
        nombreformato: "Anexo 1 Mujer Rural",
        enlaceformato:
          "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2026/Convocatorias/Anexos2026/Anexo1DignificarMujer.pdf",
      },
      {
        id: "2",
        nombreformato: "Anexo FUPS",
        enlaceformato:
          "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2026/Convocatorias/Anexos2026/FUPS_2026.pdf",
      },
      
    ]

  },
  {
    nombre: "VENTANILLA PARA DIGNIFICAR EL CAMPO HIDALGUENSE",
    enlace:
      "https://forms.gle/WEfeAWD8LQikBNPv8",
    anio: "2026",
    formatos: [
      {
        id: "1",
        nombreformato: "Anexo 1 Dignificar",
        enlaceformato:
          "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2026/Convocatorias/Anexos2026/Anexo1DignificarMujer.pdf",
      },
       {
        id: "2",
        nombreformato: "Anexo 2 Dignificar",
        enlaceformato:
          "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2026/Convocatorias/Anexos2026/Anexo2Dignificar.pdf",
      },
      {
        id: "3",
        nombreformato: "Anexo FUPS",
        enlaceformato:
          "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2026/Convocatorias/Anexos2026/FUPS_2026.pdf",
      },
      
    ]

  },
  {
    nombre: "VENTANILLA PARA TRANSFORMAR EL CAMPO HIDALGUENSE",
    enlace:
      "https://forms.gle/WEfeAWD8LQikBNPv8",
    anio: "2026",
    formatos: [
      {
        id: "1",
        nombreformato: "Anexo 1 Transformar",
        enlaceformato:
          "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2026/Convocatorias/Anexos2026/Anexo1Transformar.pdf",
      },
      {
        id: "2",
        nombreformato: "Anexo 2 FUPS",
        enlaceformato:
          "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2026/Convocatorias/Anexos2026/FUPS_2026.pdf",
      },
      
    ]

  },
   {
    nombre: "Reglas de Operación para el Otorgamiento de Subsidios y Apoyos",
    enlace:
      "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2026/Convocatorias/ReglasOperacion2026.pdf",
    anio: "2026",
     formatos: [
      {
        id: "1",
        nombreformato: "Ultima actualización enero 2026",
      },
    ]
  },
  // {
  //   nombre: "Ventanilla Seguros Catástroficos Agropecuarios",
  //   enlace:
  //     "https://forms.gle/qiLQWh4wSTBNi1CN9",
  //   anio: "2025",
  //   formatos: [
  //     {
  //       id: "1",
  //       nombreformato: "Anexo 1 ",
  //       enlaceformato:
  //         "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2025/Convocatorias/Anexos2025/Anexo1Catastrofes.pdf",
  //     },
  //     {
  //       id: "2",
  //       nombreformato: "Anexo 2 ",
  //       enlaceformato:
  //         "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2025/Convocatorias/Anexos2025/Anexo2Catastrofes.pdf",
  //     },
       
      
  //   ]
  // },
  

  {
    nombre: "TELEFONOS",
    enlace:
      "/Contacto",
    anio: "Atención",
    formatos: [
      {
        id: "1",
        nombreformato: "Telefonos de Atención",
        enlaceformato:
          "/Contacto",
      },
      
    ]

  },
  

  
]

